module.exports = __webpack_public_path__ + "img/fae5b86.jpg";